import HttpClient from "@/services/HttpClient";
import StoreService from "@/store";
import { EServices } from "@/types";
import JsonResponse from "@/utils/http/JsonResponse";
import JsonResponseErrors from "@/utils/http/JsonResponseErrors";
import IJsonResponse from "@/utils/types/IJsonResponse";
import { inject, injectable } from "tsyringe";
import { IAccount } from "../types";

@injectable()
export default class AuthClient {
  constructor(
    @inject(EServices.http) private http: HttpClient,
    @inject(EServices.store) private store: StoreService
  ) {}

  async getRegistrationOptions(): Promise<IJsonResponse> {
    const response = await this.http.get("/v1/auth/biometric/registration");

    return response;
  }

  async verifyRegisteration(options: {}): Promise<IJsonResponse> {
    const response = await this.http.post(
      "/v1/auth/biometric/registration",
      options
    );

    return response;
  }

  async getAuthenticationOptions(): Promise<IJsonResponse> {
    const response = await this.http.get("/v1/auth/biometric/authentication");

    return response;
  }

  async authenticate(options: {}): Promise<IJsonResponse> {
    const response = await this.http.post(
      "/v1/auth/biometric/authentication",
      options
    );
    const account: IAccount = response.data;
    if (account.role.name != "customer")
      throw await JsonResponse.createJsonResponse(
        undefined,
        new JsonResponseErrors(
          "you cannot access this service with this account"
        )
      );

    //Fetch the customer phone
    const customer = await this.http.get(`/v1/app/customers/${account.id}`);

    this.store.commit(
      "AccountModule/setToken",
      (response.baseResponse &&
        response.baseResponse.headers.get("authorization")) ||
        undefined
    );
    this.store.commit("AccountModule/setAccount", response.data);
    this.store.commit("AccountModule/setCustomer", customer.data);

    return response;
  }
}
